import styled from 'styled-components'
// @ts-ignore
import { Scrollama, Step } from 'react-scrollama'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import Chart from './Chart'
import { useEffect, useMemo, useState } from 'react'
import * as d3 from 'd3'
import { Small, ContentWidth, Strong, StepContent, StepContainer } from '../../theme/styles'
// import { throttle } from 'throttle-debounce'

const Scatterplot = () => {
  const [step, setStep] = useState<number>(0)
  const [data, setData] = useState<any>([])

  useEffect(() => {
    d3.csv<any>(
      `${
        process.env.NODE_ENV === 'production'
          ? 'https://dev-interaktiv-mf.tagesanzeiger.ch/2023/seasons'
          : ''
      }/marronniers-scatterplot.csv`,
      (d: any) => {
        return {
          year: +d['reference_year'],
          station: d['Station'],
          dayOfYear: +d['doy'],
          start: +d['start'],
          stop: +d['stop'],
          highlight: d['highlight'].split(',').map((v: any) => +v),
        }
      }
    )
      .then((data: any) => {
        setData(data)
      })
      .catch((error: any) => {
        console.error('Error fetching the CSV data:', error)
      })
  }, [])

  const onStepEnter = (stepData: any) => {
    setStep(stepData.data)
  }

  return (
    <Scrollyrtelling>
      <StickyChart>
        <ContentWidth>
          <Chart data={data} step={step} />
        </ContentWidth>
        <TextWidth>
          <TextOnColor>
            <Small>
              <strong>Source</strong>: MétéoSuisse
            </Small>
          </TextOnColor>
        </TextWidth>
      </StickyChart>
      <ScrollytellingContainer>
        <Scrollama offset={1} onStepEnter={onStepEnter} on>
          <Step data={0} key={`scrollama-step-${0}`}>
            <StepContainer style={{ height: '25vh' }} />
          </Step>
          <Step data={1} key={`scrollama-step-${1}`}>
            <StepContainer>
              <StepContent>
                <p>
                  MétéoSuisse a commencé à mesurer le développement des
                  marronniers à partir des années 50.
                </p>
                <p>
                  Cet arbre comptabilise <Strong color='yellow'>67 observations</Strong> pour la seule phase de déploiement des feuilles.
                </p>
              </StepContent>
            </StepContainer>
          </Step>
          <Step data={2} key={`scrollama-step-${2}`}>
            <StepContainer>
              <StepContent>
                <p>
                  Plus d'un mois sépare la date la <Strong color='yellow'>plus précoce</Strong> de la <Strong color='yellow'>plus tardive.</Strong>
                </p>
                <p>
                  Depuis le début des mesures, ces écarts ont toujours existé.
                </p>
              </StepContent>
            </StepContainer>
          </Step>
          <Step data={3} key={`scrollama-step-${3}`}>
            <StepContainer>
              <StepContent>
                <p>
                <Strong color='yellow'>L'ensemble des données suisses</Strong> montre que le verdissement de cette espèce d'arbre s'étend sur la moitié de l'année.
                </p>
                <p>Et ces chiffres dessinent une tendance...</p>
              </StepContent>
            </StepContainer>
          </Step>
          <Step data={4} key={`scrollama-step-${4}`}>
            <StepContainer>
              <StepContent>
                <p>
                  Si l'on considère le déploiement des feuilles comme le début
                  du printemps, alors celui-ci survient <Strong color='yellow'>de plus en plus tôt.</Strong>
                </p>
              </StepContent>
            </StepContainer>
          </Step>
        </Scrollama>
      </ScrollytellingContainer>
    </Scrollyrtelling>
  )
}

const Scrollyrtelling = styled.div`
  margin-bottom: 60px;
  // background: ${({ theme }) => `rgb(${theme.coloredBackground})`};
  position: relative;
`

const StickyChart = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
`

const TextOnColor = styled.div`
  // color: ${({ theme }) => `rgb(${theme.textColorOnBackground})`};
  color: var(--text-color);
`

const ScrollytellingContainer = styled.div`
  position: relative;
  width: 100%;
  pointer-events: none;
  margin-top: -120vh;
`

export default Scatterplot
